import {Injectable} from '@angular/core';
import {Router, NavigationStart} from '@angular/router';
import {Observable, Subject} from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ConfirmDialogService {
	private subject = new Subject<any>();

	constructor() {
	}

	confirmThis(title: string, message: string, type: string, template: string, siFn: () => void, noFn: () => void) {
		this.setConfirmation(title, message, type, template, siFn, noFn);
	}

	setConfirmation(title: string, message: string, type: string, template: string, siFn: () => void, noFn: () => void) {
		let that = this;
		this.subject.next({
			type: type,
			text: message,
			title: title,
			template: template,
			siFn: function () {
				siFn();
				that.subject.next(); //this will close the modal
			},
			noFn: function () {
				noFn();
				that.subject.next();
			}
		});

	}

	getModalInfo(): Observable<any> {
		return this.subject.asObservable();
	}
}
